var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    attrs: {
      "hide-header": "",
      "hide-footer": "",
      "centered": "",
      "no-close-on-backdrop": "",
      "no-stacking": ""
    },
    model: {
      value: _vm.showDialog,
      callback: function ($$v) {
        _vm.showDialog = $$v;
      },
      expression: "showDialog"
    }
  }, [_c('b-row', {
    staticClass: "mb-4",
    attrs: {
      "align-h": "between"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/icon_logo_violet.svg"),
      "alt": ""
    }
  })]), _c('b-col', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "tw-text-eclipse",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function ($event) {
        _vm.showDialog = false;
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "x-circle",
      "font-scale": "1.5"
    }
  })], 1)])], 1), _c('b-row', [_c('b-col', [_c('b-alert', {
    attrs: {
      "variant": "warning",
      "show": _vm.alert.show
    }
  }, [_vm._v(" " + _vm._s(_vm.alert.message) + " ")])], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_vm._v(" Export Filters ")]), _c('b-col', [_c('b-row', [_c('b-col', [_c('span', {
    staticClass: "text-small text-primary"
  }, [_vm._v("Stage")]), _c('b-form-select', {
    attrs: {
      "options": _vm.tabOptions
    },
    model: {
      value: _vm.selectedTab,
      callback: function ($$v) {
        _vm.selectedTab = $$v;
      },
      expression: "selectedTab"
    }
  })], 1)], 1), _c('b-row', [_c('b-col', [_c('span', {
    staticClass: "text-small text-primary"
  }, [_vm._v("Time In Category")]), _c('b-row', [_c('b-col', [_c('b-form-input', {
    attrs: {
      "placeholder": "Minimum",
      "type": "number"
    },
    model: {
      value: _vm.minimum,
      callback: function ($$v) {
        _vm.minimum = $$v;
      },
      expression: "minimum"
    }
  })], 1), _c('b-col', [_c('b-form-input', {
    attrs: {
      "placeholder": "Maximum",
      "type": "number"
    },
    model: {
      value: _vm.maximum,
      callback: function ($$v) {
        _vm.maximum = $$v;
      },
      expression: "maximum"
    }
  })], 1), _c('b-col', [_c('span', [_vm._v("Days")])])], 1)], 1)], 1), _c('b-row', {
    staticClass: "mt-3"
  }, [_c('b-col', [_c('b-button', {
    attrs: {
      "variant": "outline-primary",
      "pill": "",
      "block": ""
    },
    on: {
      "click": function ($event) {
        _vm.showDialog = false;
      }
    }
  }, [_vm._v(" Cancel ")])], 1), _c('b-col', [_c('b-button', {
    attrs: {
      "variant": "secondary",
      "pill": "",
      "block": ""
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v(" Export ")])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };